import type { StaffDutyWard } from '@his/shared';

export interface WardOption {
  id: string;
  code: string;
  name: string;
}

export interface PickerWard extends WardOption {
  onDuty: boolean;
}

export function wardPickerKey(branchId: string) {
  return ['ipd-ward-picker', branchId] as const;
}

export const WARD_PICKER_PREFIX = ['ipd-ward-picker'] as const;

export function pickerWards(duty: readonly StaffDutyWard[], others: readonly WardOption[]): PickerWard[] {
  const seen = new Set<string>();
  const wards: PickerWard[] = [];
  for (const ward of duty) {
    if (seen.has(ward.id)) continue;
    seen.add(ward.id);
    wards.push({ id: ward.id, code: ward.code, name: ward.name, onDuty: true });
  }
  for (const ward of others) {
    if (seen.has(ward.id)) continue;
    seen.add(ward.id);
    wards.push({ id: ward.id, code: ward.code, name: ward.name, onDuty: false });
  }
  return wards;
}

export function wardNameFrom(wardId: string, lists: readonly (readonly WardOption[] | undefined)[]): WardOption | null {
  for (const list of lists) {
    const found = list?.find((ward) => ward.id === wardId);
    if (found) return { id: found.id, code: found.code, name: found.name };
  }
  return null;
}
